import React from "react";
import Fade from "react-reveal/Fade";
import "./About.css";

function About() {
  return (
    <div className="about">
      <div className="about-me">
        <Fade top>
          <h1>✨ABOUT ME</h1>
        </Fade>

        <Fade left>
          <p>
            I am a student currently pursuing Computer Science from Indian
            Institute of Information Technology Vadodara. I was always
            fascinated by how computers work and found it interesting. When I
            was a child, I was absolutely attracted by computer games and later
            it was programming.I spend most of my spare time designing programs
            and web pages because I enjoy problem solving and logical thinking.
          </p>
        </Fade>
      </div>

      <div className="basketball">
        <Fade top>
          <h1>✨BASKETBALL</h1>
        </Fade>

        <Fade left>
          <p>
            I always liked the competitive aspect of basketball. It always keeps
            us on our toes since it is a really fast paced game. There is always
            a chance for a comeback and we have to be alert all the time. Also,
            the 3-pointers are really satisfying when the team is counting on
            you ; )
          </p>
        </Fade>
      </div>

      <div className="anime">
        <Fade top>
          <h1>✨ANIME</h1>
        </Fade>
        <Fade left>
        <p>Anime holds a special place in my heart. Whenever I watch anime it fills me with confidence to overcome even the hardest obstacles. Also, the fight scenes are 🔥🔥. <span style={{color:"#ff2895", fontWeight:"bold", fontSize:"25px"}}>Naruto</span> and <span style={{color:"#ff2895", fontWeight:"bold", fontSize:"25px"}}>My Hero Academia</span> are my favorite✨✨</p>
        </Fade>
      </div>

      <div className="other-interests">
        <Fade top>
         <h1>✨OTHER INTERESTS</h1>
        </Fade>

        <Fade left>
         <p>In my free time I enjoy playing games(mostly FPS games) as it allows me let go of my worries and be tension-free. It relaxes my mind and prevents me from getting tensed.</p>
        </Fade>
      </div>
    </div>
  );
}

export default About;
